import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../../../services/auth.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { SNACKBAR_DURATION } from '../../../../shared/constants/snackbar.constants';
import { from, switchMap } from 'rxjs';

@Component({
  selector: 'tgrid-forgot-password',
  imports: [
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    FormsModule,
],
  templateUrl: './forgot-password.component.html',
  standalone: true,
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {

  private router = inject(Router);
  private authService = inject(AuthService);
  private snackBar = inject(MatSnackBar);

  public passwordRequestGroup: FormGroup;
  public responseCode: number;

  constructor() {
      this.passwordRequestGroup = new FormGroup({
      email: new FormControl('', {validators: Validators.required}),
    });
  }

  requestPassword() {
    const emailText = this.passwordRequestGroup.get('email')?.value;
    this.authService.requestPasswordReset(emailText).pipe(
      switchMap(() => {
        this.snackBar.open('Email sent!', 'Close', {
          duration: SNACKBAR_DURATION.LONG,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['custom-snackbar', 'snackbar-success'],
        });
        return from(this.router.navigate(['/login']));
      }),
    ).subscribe({
      next: (success) => {
        if (!success) {
          console.error('Navigation to /login failed');
          this.snackBar.open('Password reset email sent, but navigation failed.', 'Close', {
            duration: SNACKBAR_DURATION.LONG,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['custom-snackbar', 'snackbar-error'],
          });
        }
      },
      error: (err) => {
        console.error('Password reset request failed:', err);
        this.snackBar.open('Failed to send reset email. Please try again.', 'Close', {
          duration: SNACKBAR_DURATION.LONG,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['custom-snackbar', 'snackbar-error'],
        });
      },
    });
  }

  goBack() {
    // noinspection JSIgnoredPromiseFromCall
    this.router.navigateByUrl('/login');
  }

}

